import { Spot } from "Domain/Model/Spot/Spot";

export const FIND_SPOT_SUCCESS = 'FIND_SPOT_SUCCESS';

export const findSpotSuccess = (spot: Record<string, Spot>) => ({
    type: FIND_SPOT_SUCCESS,
    payload: { spot },
});
